var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  disabled: _vm.readonly,
                  inline: true,
                  "label-position": "left",
                  "label-width": "75px"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, no: "jobNo" },
                      model: {
                        value: _vm.job.jobNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "jobNo", $$v)
                        },
                        expression: "job.jobNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.MasterBillNo") } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            _vm.job.express || _vm.mblCodeNumValidate
                              ? ""
                              : _vm.$t("queryJob.TheDoesNotComplyRules"),
                          placement: "right-end"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: { no: "express" },
                                model: {
                                  value: _vm.job.express,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "express", $$v)
                                  },
                                  expression: "job.express"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                            ),
                            _c("cargo-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.job.express,
                                  expression: "job.express"
                                }
                              ],
                              staticStyle: {
                                width: "170px",
                                "margin-right": "20px"
                              },
                              attrs: {
                                no: "mbl",
                                maxlength: 32,
                                "input-convert": _vm.filterNonDigit
                              },
                              model: {
                                value: _vm.job.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mbl", $$v)
                                },
                                expression: "job.mbl"
                              }
                            }),
                            _c("cargo-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.job.express,
                                  expression: "!job.express"
                                }
                              ],
                              class: _vm.mblCodeNumValidate ? "" : "red",
                              staticStyle: {
                                width: "60px",
                                "margin-left": "2px"
                              },
                              attrs: {
                                value: _vm.mblCode,
                                no: "mblCode",
                                maxlength: 3,
                                "input-convert": _vm.filterNonDigit
                              },
                              on: {
                                input: _vm.onMblCodeInput,
                                blur: _vm.onMblCodeNumBlur
                              }
                            }),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.job.express,
                                    expression: "!job.express"
                                  }
                                ],
                                staticStyle: {
                                  "padding-right": "2.5px",
                                  "padding-left": "2.5px"
                                }
                              },
                              [_vm._v("-")]
                            ),
                            _c("cargo-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.job.express,
                                  expression: "!job.express"
                                }
                              ],
                              ref: "mblNum",
                              class: _vm.mblCodeNumValidate ? "" : "red",
                              staticStyle: {
                                width: "108px",
                                "margin-right": "20px"
                              },
                              attrs: {
                                no: "mblNum",
                                maxlength: 8,
                                "input-convert": _vm.filterNonDigit
                              },
                              on: { blur: _vm.onMblCodeNumBlur },
                              model: {
                                value: _vm.mblNum,
                                callback: function($$v) {
                                  _vm.mblNum = $$v
                                },
                                expression: "mblNum"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                  [
                    _c("so-no-input", {
                      attrs: { disabled: _vm.readonly, no: "jobSoNo" },
                      model: {
                        value: _vm.job.jobSoNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "jobSoNo", $$v)
                        },
                        expression: "job.jobSoNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.CustomerReferenceNumber")
                    }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "customerRefNo",
                        "auto-uppercase": true,
                        trim: true
                      },
                      model: {
                        value: _vm.job.customerRefNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customerRefNo", $$v)
                        },
                        expression: "job.customerRefNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "usCustomsClearance" },
                    model: {
                      value: _vm.job.usCustomsClearance,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "usCustomsClearance", $$v)
                      },
                      expression: "job.usCustomsClearance"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.UsCustomsClearance")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "isInsure" },
                    model: {
                      value: _vm.job.insure,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "insure", $$v)
                      },
                      expression: "job.insure"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_insurance_toInsure"],
                        expression: "['button_insurance_toInsure']"
                      }
                    ],
                    class: !_vm.isEdit
                      ? "el-button el-button--primary el-button--mini"
                      : "el-button el-button--primary el-button--mini is-disabled",
                    staticStyle: {
                      "min-width": "50px!important",
                      "margin-left": "15px"
                    },
                    attrs: { id: "toInsure", type: "primary" },
                    on: {
                      click: function() {
                        if (!_vm.isEdit) {
                          _vm.toInsure()
                        }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")) + " ")]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { display: "flex" },
                attrs: { "label-position": "right", "label-width": "120px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _vm.isZY
                      ? [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_AllowSaleProduct,
                                  disabled: _vm.readonly,
                                  filterable: "",
                                  no: "allowSaleProduct",
                                  clearable: "",
                                  "data-filter-function": function(p) {
                                    return p.statusEnabled && p.airImportEnabled
                                  },
                                  "default-value": _vm.job.saleProductCode || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.saleProductCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.FullOrInside"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_FullOrInside$FULL_OR_INSIDE,
                                  disabled: _vm.readonly,
                                  no: "fullOrInside",
                                  clearable: "",
                                  "default-value": _vm.job.fullOrInside || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.fullOrInside = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoSource",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.local_cache_CargoSource,
                            "callback-method-type": "value",
                            "default-value": _vm.job.cargoSource,
                            "callback-params": { key: "cargoSource" },
                            clearable: false,
                            placeholder: " "
                          },
                          on: { parentCallBack: _vm.cargoSource_Change }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "customJobType",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_CutomJobType,
                            "method-params": { type: _vm.job.lob },
                            "default-value": _vm.job.customJobType,
                            "static-options": _vm.customJobTypeList
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.customJobType = p.value
                              _vm.onCustomJobTypeChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.customJobType &&
                    _vm.secondaryCustomJobTypeList.length > 0
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                          [
                            _c("cargo-advance-select", {
                              ref: "secondaryCustomJobType",
                              attrs: {
                                no: "secondaryCustomJobType",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_CutomJobType,
                                filterable: "",
                                cache: false,
                                "default-value": _vm.job.secondaryCustomJobType,
                                "tag-name": _vm.isZh ? "name" : "englishName",
                                "static-options": _vm.secondaryCustomJobTypeList
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.secondaryCustomJobType = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.job.cargoSource === "NC",
                            expression: "job.cargoSource==='NC'"
                          }
                        ]
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "designationAgent",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "default-value": _vm.job.designationAgent || "",
                            "tag-name": "englishName",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: {
                            parentCallBack: _vm.designationAgentChangeHandler
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                      [
                        _c("el-input", {
                          attrs: { disabled: true, no: "salesChannel" },
                          model: {
                            value: _vm.job.salesChannel,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "salesChannel", $$v)
                            },
                            expression: "job.salesChannel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ConsignationRelationNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "trustFromJob",
                            value: _vm.job.trustFromJob,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SeaExport.BusinessCommissionedRelationNumber"
                          )
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "relatedJob",
                            value: _vm.job.relatedJob,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.PortOfLoadingAgent") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "loadingAgentId",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "callback-params": { key: "loadingAgentId" },
                            "callback-method-type": "value",
                            "tag-name": "englishName",
                            "default-value": _vm.job.loadingAgentId || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.setJobSelectNum(p)
                              _vm.OverseaCustomerUtils.destinationAgentChangeHandler(
                                _vm.view
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineCompany") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrierId",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { airCmp: true, active: true },
                            "default-value": _vm.job.carrierId || "",
                            placeholder: " "
                          },
                          on: { parentCallBack: _vm.txtCarrierId_changeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Flight") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "voyageFlight",
                            "auto-uppercase": true
                          },
                          model: {
                            value: _vm.job.voyageFlight,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "voyageFlight", $$v)
                            },
                            expression: "job.voyageFlight"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.bookingAgentVisible
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.BookingAgent") }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "bookingAgent",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  bookingAgent: true,
                                  active: true
                                },
                                "callback-params": { key: "bookingAgent" },
                                "callback-method-type": "value",
                                "default-value": _vm.job.bookingAgent || "",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(obj) {
                                  _vm.setJobSelectNum(obj)
                                  _vm.job.groundAgentId = _vm.job.bookingAgent
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.BillExchangeAgent") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "exChangeAgent",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              bookingAgent: true,
                              active: true
                            },
                            "callback-params": { key: "exChangeAgent" },
                            "callback-method-type": "value",
                            "default-value": _vm.job.exChangeAgent || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(obj) {
                              _vm.setJobSelectNum(obj)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "dispatchingPlace",
                            "auto-uppercase": true
                          },
                          model: {
                            value: _vm.job.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dispatchingPlace", $$v)
                            },
                            expression: "job.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.LoadingPort")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "loadingPortCode",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "callback-params": { key: "loadingPortCode" },
                            "callback-method-type": "value",
                            "default-value": _vm.valueMatch.loadingPortCode
                              ? _vm.job.loadingPortCode
                              : "",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: {
                            parentCallBack: function(obj) {
                              _vm.valueMatch.loadingPortCode = true
                              _vm.loadingPortCodeChange(obj)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.PortOfDestination"))
                            )
                          ]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "dischargingPortCode",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "default-value": _vm.valueMatch.dischargingPortCode
                              ? _vm.job.dischargingPortCode
                              : "",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.dischargingPortCode_Change }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.FinalPlaceOfDelivery"))
                            )
                          ]
                        ),
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "destinationPlace",
                            "auto-uppercase": true,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          model: {
                            value: _vm.job.destinationPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destinationPlace", $$v)
                            },
                            expression: "job.destinationPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Airline") } },
                      [
                        _c("el-input", {
                          attrs: { no: "airline", disabled: true },
                          model: {
                            value: _vm.job.regionName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "regionName", $$v)
                            },
                            expression: "job.regionName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "customsDate",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.job.customsDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customsDate", $$v)
                            },
                            expression: "job.customsDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "etd",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "etd",
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm",
                              clearable: "",
                              placeholder: ""
                            },
                            on: {
                              input: _vm.etdChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "etd",
                                  _vm.etdChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "etd", $$v)
                              },
                              expression: "job.etd"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("filterWeek")(_vm.job.sailingDay))
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))]
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "eta",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "eta",
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm",
                              clearable: "",
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              input: _vm.etaChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "eta",
                                  _vm.etaChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "eta", $$v)
                              },
                              expression: "job.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.ActualDateOfDeparture2"))
                        )
                      ]),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "atd",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "atd",
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm",
                              clearable: ""
                            },
                            on: {
                              input: _vm.atdChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "atd",
                                  _vm.atdChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.atd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "atd", $$v)
                              },
                              expression: "job.atd"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.atdSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ActualDateOfArrival2")))
                      ]),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "ata",
                            staticStyle: {
                              flex: "1",
                              width: "170px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "ata",
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm",
                              clearable: ""
                            },
                            on: {
                              input: _vm.ataChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "ata",
                                  _vm.ataChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.ata,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "ata", $$v)
                              },
                              expression: "job.ata"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.ataSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoCode",
                            "select-type":
                              _vm.selectTypeNames.basic_data_CargoInformation,
                            disabled: _vm.readonly,
                            filterable: "",
                            "callback-params": { key: "cargoCode" },
                            "default-value": _vm.job.cargoCode,
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: _vm.txtCargoInformationChangeHandler
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly || !_vm.job.cargoCode,
                            no: "cargoName"
                          },
                          model: {
                            value: _vm.job.cargoName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoName", $$v)
                            },
                            expression: "job.cargoName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.TerminalAddress") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "deliveryAddress",
                            disabled: _vm.readonly
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("Message.TerminalAddress"),
                                _vm.job.deliveryAddress,
                                undefined,
                                function(val) {
                                  _vm.job.deliveryAddress = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.deliveryAddress,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "deliveryAddress", $$v)
                            },
                            expression: "job.deliveryAddress"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_TransportSource")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_TransportSource,
                            no: "transportSource",
                            "default-value": _vm.job.transportSource,
                            cache: false,
                            "tag-value": "code",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(item) {
                              return (_vm.job.transportSource = item.value)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ServiceStatisticalArea")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_StatisticArea,
                            no: "statisticArea",
                            "default-value": _vm.job.statisticArea,
                            cache: false,
                            "tag-value": "code",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(item) {
                              return (_vm.job.statisticArea = item.value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    style: _vm.$selectByLang("", "width: 350px")
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfDelivery") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "deliverDate",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.job.deliverDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "deliverDate", $$v)
                            },
                            expression: "job.deliverDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DateOfArrivalTheWarehouse")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "arriveStorageDate",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.job.arriveStorageDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "arriveStorageDate", $$v)
                            },
                            expression: "job.arriveStorageDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "CopyFromOtherBill",
                                disabled: _vm.readonly
                              },
                              on: {
                                click: function($event) {
                                  _vm.importPromptTitleDialog.visible = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "CodeSearching",
                                disabled: _vm.readonly
                              },
                              on: {
                                click: function($event) {
                                  _vm.billAddressDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "90px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "shipperCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.$t("Tool.Code")
                              },
                              model: {
                                value: _vm.job.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipperCode", $$v)
                                },
                                expression: "job.shipperCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "shipperId",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value": _vm.job.shipperId || "",
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: _vm.shipperAutoCompleteChange
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "shipperLine1",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                undefined,
                                _vm.splitShipperLine
                              )
                            }
                          },
                          model: {
                            value: _vm.job.shipperLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine1", $$v)
                            },
                            expression: "job.shipperLine1"
                          }
                        }),
                        _c("char-count", {
                          staticStyle: { float: "right" },
                          attrs: {
                            inline: "",
                            form: _vm.job,
                            prefix: "shipper"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "90px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.$t("Tool.Code")
                              },
                              model: {
                                value: _vm.job.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consigneeCode", $$v)
                                },
                                expression: "job.consigneeCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "consigneeId",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { consignee: true },
                                "default-value": _vm.job.consigneeId || "",
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: _vm.consigneeAutoCompleteChange
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "consigneeLine1",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Consignee"),
                                _vm.mergeConsigneeLine(),
                                undefined,
                                _vm.splitConsigneeLine
                              )
                            }
                          },
                          model: {
                            value: _vm.job.consigneeLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine1", $$v)
                            },
                            expression: "job.consigneeLine1"
                          }
                        }),
                        _c("char-count", {
                          staticStyle: { float: "right" },
                          attrs: {
                            inline: "",
                            form: _vm.job,
                            prefix: "consignee"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "90px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyCode",
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                placeholder: _vm.$t("Tool.Code")
                              },
                              model: {
                                value: _vm.job.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notifyCode", $$v)
                                },
                                expression: "job.notifyCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "notifyId",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { notify: true },
                                "default-value": _vm.job.notifyId || "",
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: _vm.notifyAutoCompleteChange
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "notifyLine1",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify,
                            "use-read-only": true,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.NotifyParty"),
                                _vm.mergeNotifyLine(),
                                undefined,
                                _vm.splitNotifyLine
                              )
                            }
                          },
                          model: {
                            value: _vm.job.notifyLine1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine1", $$v)
                            },
                            expression: "job.notifyLine1"
                          }
                        }),
                        _c("char-count", {
                          staticStyle: { float: "right" },
                          attrs: { inline: "", form: _vm.job, prefix: "notify" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualQuantity") } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "quantityContract",
                            precision: 0,
                            min: 0
                          },
                          on: { change: _vm.quantityContractChange },
                          model: {
                            value: _vm.job.quantityActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "quantityActual", $$v)
                            },
                            expression: "job.quantityActual"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Package") } },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "packing",
                            disabled: _vm.readonly,
                            "default-value": _vm.job.packing,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              p.key = "packing"
                              _vm.setJobSelectValue(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualWeight") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "weightContract",
                                precision: 3,
                                min: 0
                              },
                              on: { change: _vm.weightContractChange },
                              model: {
                                value: _vm.job.weightActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "weightActual", $$v)
                                },
                                expression: "job.weightActual"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [_c("span", [_vm._v("KGS")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ActualVolume") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("auto-number-input", {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "cubageContract",
                                precision: 3,
                                min: 0
                              },
                              on: { change: _vm.cubageContractChange },
                              model: {
                                value: _vm.job.cubageActual,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cubageActual", $$v)
                                },
                                expression: "job.cubageActual"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [_c("span", [_vm._v("CBM")])]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ChargedWeight") } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "chargeWeight",
                            precision: 3,
                            min: 0
                          },
                          model: {
                            value: _vm.job.chargeWeight,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "chargeWeight", $$v)
                            },
                            expression: "job.chargeWeight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "cargoChineseName",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                _vm.job.cargoChineseName,
                                0,
                                function(val) {
                                  _vm.job.cargoChineseName = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoChineseName", $$v)
                            },
                            expression: "job.cargoChineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { position: "relative" } },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "cargoEnglishName",
                                type: "textarea",
                                rows: 3,
                                "auto-uppercase": _vm.isUppercaseByConfig
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t(
                                      "SeaExport.EnglishDescriptionOfGoods"
                                    ),
                                    _vm.job.cargoEnglishName,
                                    0,
                                    function(val) {
                                      _vm.job.cargoEnglishName = val
                                    },
                                    _vm.isUppercaseByConfig
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.cargoEnglishName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "cargoEnglishName", $$v)
                                },
                                expression: "job.cargoEnglishName"
                              }
                            }),
                            _c("char-count", {
                              attrs: { value: _vm.job.cargoEnglishName }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Marks") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { position: "relative" } },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "mark",
                                type: "textarea",
                                rows: 3,
                                "auto-uppercase": _vm.isUppercaseByConfig
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Marks"),
                                    _vm.job.mark,
                                    0,
                                    function(val) {
                                      _vm.job.mark = val
                                    },
                                    _vm.isUppercaseByConfig
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.mark,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mark", $$v)
                                },
                                expression: "job.mark"
                              }
                            }),
                            _c("char-count", { attrs: { value: _vm.job.mark } })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PreCollection") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { "flex-grow": "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "depositReceived",
                                controls: false,
                                precision: 3
                              },
                              model: {
                                value: _vm.job.depositReceived,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "depositReceived", $$v)
                                },
                                expression: "job.depositReceived"
                              }
                            }),
                            _c("span", [_vm._v(_vm._s(_vm.localCurrency))])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "remarks",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Remarks"),
                                _vm.job.remarks,
                                0,
                                function(val) {
                                  _vm.job.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "remarks", $$v)
                            },
                            expression: "job.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form-item",
                      {
                        class: _vm.poNoRed ? "poNoClass" : "",
                        attrs: { label: _vm.$t("SeaExport.ItemNo") }
                      },
                      [
                        !_vm.openProjectConfig
                          ? _c("cargo-input", {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "poNo",
                                "auto-uppercase": true
                              },
                              model: {
                                value: _vm.job.poNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "poNo", $$v)
                                },
                                expression: "job.poNo"
                              }
                            })
                          : _vm._e(),
                        _vm.openProjectConfig
                          ? _c("cargo-project-select", {
                              attrs: {
                                disabled: _vm.readonly,
                                no: "poNo",
                                "default-value": _vm.job.poNo,
                                "customer-id": _vm.job.customerId
                              },
                              on: { change: _vm.changeProject }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.openProjectConfig
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "projectName" },
                              model: {
                                value: _vm.job.projectName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "projectName", $$v)
                                },
                                expression: "job.projectName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.TransportationClause")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "freightTerm",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_ShippingTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.freightTerm,
                            "callback-params": { key: "freightTerm" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoType",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_CargoType,
                            "method-params": { air: true },
                            "callback-method-type": "value",
                            "default-value": _vm.job.cargoType,
                            "callback-params": { key: "cargoType" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.onCargoTypeChagne }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.MasterBLFreightTerm")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "paymentTermMBL",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_PaymentTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.paymentTermMBL,
                            "callback-params": { key: "paymentTermMBL" },
                            clearable: false,
                            placeholder: " "
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "incoTerm",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_IncoTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.incoTerm,
                            "callback-params": { key: "incoTerm" },
                            clearable: false,
                            placeholder: " "
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "tradeTerm",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_TradeTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.tradeTerm,
                            "callback-params": { key: "tradeTerm" },
                            clearable: false
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.BillExchangeDate") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "transDate",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.job.transDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "transDate", $$v)
                            },
                            expression: "job.transDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.AirportHandlingAgent")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "groundAgentId",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              bookingAgent: true,
                              active: true
                            },
                            "callback-params": { key: "groundAgentId" },
                            "callback-method-type": "value",
                            "default-value": _vm.job.groundAgentId || "",
                            placeholder: " "
                          },
                          on: { parentCallBack: _vm.setJobSelectNum }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                      [
                        _c("el-input", {
                          attrs: { disabled: true, no: "txtSalesOffice" },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Sales") } },
                      [
                        _c("cargo-user-select", {
                          ref: "sales",
                          attrs: {
                            disabled:
                              _vm.readonly || _vm.isWithinCloseAccountDate,
                            no: "sales",
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.job.sales || "",
                            placeholder: " "
                          },
                          on: { change: _vm.salesChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "cargoSalesId",
                            disabled: _vm.readonly,
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || "",
                            placeholder: " "
                          },
                          on: { change: _vm.cargoSalesChargeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesDepartment") } },
                      [
                        _c("cargo-department-new-select", {
                          attrs: {
                            disabled: _vm.readonly || !_vm.job.sales,
                            no: "salesOffice",
                            "sales-id": Number(_vm.job.sales),
                            enables: true,
                            "office-id": _vm.job.salesOffice,
                            "department-id": Number(_vm.job.salesDepartment)
                          },
                          on: { change: _vm.departmentChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "opOffice",
                            disabled: _vm.readonly || _vm.opOfficeDisabled,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Office,
                            filterable: "",
                            "callback-params": { key: "opOffice" },
                            "static-options": _vm.cacheOffices,
                            "callback-method-type": "value",
                            "default-value": _vm.job.opOffice || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.opOffice = p.value
                              _vm.job.opDepartment = 0
                              _vm.opOfficeChargeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_OperationDepartment")
                              )
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            disabled:
                              _vm.readonly || _vm.isWithinCloseAccountDate,
                            no: "opDepartment",
                            enables: true,
                            "office-id": Number(_vm.job.opOffice),
                            "department-id": Number(_vm.job.opDepartment),
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "csr",
                            disabled: _vm.readonly,
                            "method-params": { category: "role", shape: "csr" },
                            "default-value": _vm.job.csr || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.csr
                          },
                          on: { change: _vm.csrChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Operation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "op",
                            "method-params": {
                              category: "role",
                              shape: "op",
                              officeId:
                                _vm.$store.getters.currentOffice.code === "HB"
                                  ? ""
                                  : _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.op || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.op
                          },
                          on: { change: _vm.opChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Documents") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "dc",
                            "method-params": { category: "role", shape: "doc" },
                            "default-value": _vm.job.dc || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.doc
                          },
                          on: { change: _vm.dcChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "plannerOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.plannerOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerOffice = p.value
                              _vm.job.plannerDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AirlineDepartment"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "plannerDepartment",
                            disabled: _vm.readonly,
                            "office-id": Number(_vm.job.plannerOffice),
                            enables: true,
                            "department-id": Number(_vm.job.plannerDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_AirlinePerson") }
                      },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "planner",
                            disabled: _vm.readonly,
                            "method-params": {
                              category: "role",
                              shape: "airline"
                            },
                            "default-value": _vm.job.planner || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.airline
                          },
                          on: { change: _vm.plannerChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PolOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "loadingPortOp",
                            disabled: _vm.readonly,
                            "method-params": {
                              category: "role",
                              shape: "aiop"
                            },
                            "default-value": _vm.job.loadingPortOp || "",
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.loadingPortOp = p.value || 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PodOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "destinationPortOp",
                            disabled: _vm.readonly,
                            "method-params": {
                              category: "role",
                              shape: "aiop"
                            },
                            "default-value": _vm.job.destinationPortOp || "",
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.destinationPortOp = p.value || 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.siteOp
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.OverseaCustomerService")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "overseaOp",
                          staticClass: "input2",
                          attrs: {
                            no: "overseaOp",
                            disabled: _vm.readonly,
                            "default-value": _vm.job.overseaOp || "",
                            "static-options":
                              _vm.userPortRoleData.overseaOp ||
                              _vm.overseaAgentUsersList,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.job.overseaOp = p.value
                              _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                                _vm.view,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAddUserDefinedRoles,
                            expression: "isAddUserDefinedRoles"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "userDefinedRoleId1",
                          attrs: {
                            no: "userDefinedRoleId1",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole1"
                            },
                            "default-value": _vm.job.userDefinedRoleId1 || "",
                            "merge-load": true,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.userDefinedRoleId1Handler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAddUserDefinedRoles,
                            expression: "isAddUserDefinedRoles"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "userDefinedRoleId2",
                          attrs: {
                            no: "userDefinedRoleId2",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole2"
                            },
                            "default-value": _vm.job.userDefinedRoleId2 || "",
                            "merge-load": true,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.userDefinedRoleId2Handler(p)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField1") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "userDefinedField1",
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField1"),
                                _vm.job.userDefinedField1,
                                0,
                                function(val) {
                                  _vm.job.userDefinedField1 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField1", $$v)
                            },
                            expression: "job.userDefinedField1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField2") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "userDefinedField2",
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField2"),
                                _vm.job.userDefinedField2,
                                0,
                                function(val) {
                                  _vm.job.userDefinedField2 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField2,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField2", $$v)
                            },
                            expression: "job.userDefinedField2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField3") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "userDefinedField3",
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField3"),
                                _vm.job.userDefinedField3,
                                0,
                                function(val) {
                                  _vm.job.userDefinedField3 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField3,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField3", $$v)
                            },
                            expression: "job.userDefinedField3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField4") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "userDefinedField4",
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField4"),
                                _vm.job.userDefinedField4,
                                0,
                                function(val) {
                                  _vm.job.userDefinedField4 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField4,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField4", $$v)
                            },
                            expression: "job.userDefinedField4"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.readonly,
                              no: "taxNature",
                              placeholder: _vm.$t("SeaExport.PleaseSelect"),
                              size: "mini"
                            },
                            model: {
                              value: _vm.job.taxNature,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "taxNature", $$v)
                              },
                              expression: "job.taxNature"
                            }
                          },
                          _vm._l(_vm.TAX_NATURES, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.TicketsInfo")))
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "margin-bottom": "5px",
                  "line-height": "28px"
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                ]),
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v(
                    _vm._s(_vm.job.lclSlaves ? _vm.job.lclSlaves.length : 0)
                  )
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.readonly && _vm.viewSource === "bookingWorkspace",
                        expression: "readonly&&viewSource==='bookingWorkspace'"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "NewTickets", type: "primary" },
                        on: { click: _vm.addTicket_clickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "EditTickets", type: "primary" },
                        on: { click: _vm.editTicket_clickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "AddTickets", type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.queryAILclDialog.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "AddTickets", type: "danger" },
                        on: { click: _vm.removeTicket_clickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "min-height": "200px",
                  "flex-direction": "column"
                }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { height: "300px" },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.lclSlaves
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                          "：" +
                          _vm._s(_vm.lbTotal.lblTotalQuantity)
                      )
                    ]),
                    _c("div", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.TotalWeight2")) +
                          "：" +
                          _vm._s(_vm.lbTotal.lblTotalWeight)
                      )
                    ]),
                    _c("div", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                          "：" +
                          _vm._s(_vm.lbTotal.lblTotalCubage)
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c("import-prompt-title-dialog", {
        attrs: {
          visible: _vm.importPromptTitleDialog.visible,
          lob: _vm.job.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.importPromptTitleDialog, "visible", $event)
          },
          selected: _vm.onExcerptionChangeFunc
        }
      }),
      _c("import-bill-address-title-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "665px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.textChars,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": -1
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("query-ai-lcl-dialog", {
        attrs: { visible: _vm.queryAILclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryAILclDialog, "visible", $event)
          },
          callback: _vm.slavedAddedHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }